import React from 'react';

import classNames from 'classnames';

import './spinner.scss';

interface IProps {
  className?: string;
}

const Spinner: React.FC<IProps> = ({ className }) => (
  <div
    className={classNames('spinner', {
      'spinner--visible': true,
    })}
  >
    <div className="loadingSpinner" />
  </div>
);

export default Spinner;
